// 篮球 杯赛
export default {
  data() {
    return {
      containerFullClassName: 'containerFull_basketball_cup',
      defaultPath: ['basketball', 'FIBAWA', 'schedule'],
      axiosBaseUrl: '/bkbcup',
      sportCompetitionType: 'basketball_FIBAWA', //暂时不加具体中网|汤尤杯这种赛事区别，如果需要后面补字段即可【tennis_chinaOpen,badminton_thomasAndUber, compreSportsMeet_ASG】
      themeSeasonArr: [
        {
          sidArr: ['2022025', '2022023'],
          themeIndex: 0,
        },
      ],
    }
  },
}
